export default {
  metrics: {
    pickup: 'Afhalen',
    internal_delivery: 'Interne bezorging',
    external_delivery: 'Externe bezorging',
  },
  events: {
    add_to_basket: 'Artikel toevoegen',
    begin_checkout: 'Naar afrekenen',
    begin_purchase: 'Betaling starten',
    complete_purchase: 'Betaling voltooien',
    order_placed: 'Betaling voltooien',
    view_item: 'Artikel bekijken',
  },
};
